module.exports = __webpack_public_path__ + "static/media/green_card_bg.54a95fe7.png";